import React, { useEffect, useState } from 'react'
import { superAxiosRequest } from 'axiosApi'
import { localisationMaster } from 'Localisation/Localisation'
import Stores from 'Stores'
import ContentHeader from '../Global/ContentHeader'
import GroupFilter from './components/GroupFilter'
import SurfMenu from './components/SurfMenu'
import GroupUserUnit from './components/GroupUserUnit'
import Loader from '../Global/Loader/Loader'

export default function GroupListClients(props) {
  const { profileId } = Stores
  const [udata, setUdata] = useState(null)
  const [gropsList, setgropsList] = useState([false, []])
  const [type, settype] = useState(1)
  const initFilter = {
    online: true,
  }
  const [filter, setFilter] = useState(initFilter)

  const menu = [
    {
      name: localisationMaster('text_3', 'groups/all-groups'),
      active: true,
      link: 1,
    },
    {
      name: localisationMaster('text_4', 'groups/all-groups'),
      active: false,
      link: 2,
    },
  ]

  const onlineStatus = [
    { id: true, name: 'Online' },
    { id: false, name: 'Offline' },
  ]

  const dropFilters = () => {
    setFilter({ ...initFilter })
    getList(initFilter)
  }

  const filterChangeHandler = (val, key) => {
    setFilter({ ...filter, [key]: val })
  }

  const getList = (f) => {
    let fil = { ...filter }
    if (!!f) fil = { ...f }

    let apiConf = {
      method: 'get',
      link: 'groups/for_subscribe',
      params: {
        status: type,
        limit: 999,
        ...fil,
      },
    }
    superAxiosRequest(apiConf)
      .then((response) => {
        setgropsList([true, response.data.result])
      })
      .catch(() => {
        setgropsList([true, []])
      })
  }

  const changeType = (data) => {
    settype(data)
  }

  useEffect(() => {
    setgropsList([true, []])
    getList()
  }, [type])

  useEffect(() => {
    if (profileId === +props.match.params['id'] || !props.match.params['id'])
      return
    superAxiosRequest({
      link: 'accounts/client_info/' + +props.match.params['id'],
      method: 'get',
    }).then((res) => setUdata(res.data))
  }, [])

  return (
    <>
      <ContentHeader
        title={localisationMaster('text_472', 'groups/all-groups')}
      />
      <GroupFilter
        data={filter}
        onChange={filterChangeHandler}
        drop={dropFilters}
        setFilter={getList}
        onlineStatus={onlineStatus}
        type={type}
        settype={settype}
      />
      <SurfMenu menu={menu} changeType={changeType} type={type} />
      {!gropsList[0] ? (
        <Loader />
      ) : (
        <div className='user-group-listing'>
          {gropsList[0] && gropsList[1].length > 0 ? (
            gropsList[1].map((item, index) => (
              <GroupUserUnit
                drop={dropFilters}
                key={index}
                items={item}
                udata={udata}
                id_user={+props.match.params['id'] || profileId}
              />
            ))
          ) : (
            <div className='sg-probka'>
              {localisationMaster('text_21', 'groups/all-groups')}
            </div>
          )}
        </div>
      )}
    </>
  )
}
